module.exports = "//imgak.mmtcdn.com/rails_cdn_dt/static/media/ic-failure@2x.3b468cb1.png";